const reportsFindings = ({ rangeDays = 0, tab = "", actions = {} } = {}) => {
  const out = [];
  if (rangeDays > 0 && rangeDays < 7) {
    out.push({
      tone: "neutral",
      key: "short_window",
      label: "Window too short to judge",
      text: `${rangeDays} days is noise for reply rates. Look at 30.`,
      actions: actions.widen ? [{ label: "Use 30 days", run: actions.widen }] : []
    });
  }
  if (tab) {
    out.push({
      tone: "neutral",
      key: "explain_change",
      label: "Explain a change",
      text: "Ask why a number moved and I will say what drove it, not just repeat it.",
      actions: actions.explainChange ? [{ label: "Explain a change", run: actions.explainChange }] : []
    });
    out.push({
      tone: "neutral",
      key: "weekly_digest",
      label: "Weekly digest",
      text: "A five-line summary of this report you can paste to your manager.",
      actions: actions.weeklyDigest ? [{ label: "Weekly digest", run: actions.weeklyDigest }] : []
    });
  }
  return out;
};

export default reportsFindings;
